export interface IOrder {
  isCrm?: boolean
  code: number
  objectId: string
  statusCall?: EORDER_STATUS_CALL
  quantity: number
  discount: number
  status?: EOrderStatus
  subTotal: number
  sender: IOrderSender
  total: number
  commission?: number
  paymentDate?: Date | string
  trackingCode?: string
  paymentUrl?: string
  type?: EOrderType
  shippingProvider?: OrderShippingProvider | null
  tracking?: OrderTrackings[] | null
  items: IOrderItem[]
  assignTelesaleBy?: string
  paymentMethod?: EOrderType
  distribution?: {
    name: string
    type: string
    url: string
  }
  actor: string
  username: string
  trackingProvider?: string
  providerStatus?: string
  providerStatusText?: string
  recipient: OrderRecipient
  isCod?: boolean
  pickUpAt?: Date
  printedAt?: Date
  orderDate?: Date
  createdTrackingAt?: Date
  trackingUpdatedAt?: Date
  platform?: string
  isTransacted?: boolean
  createdAt?: Date
  updatedAt?: Date
  note?: string
  isTelesale?: boolean
  actions?: {
    actor: string
    createdAt: Date | string
    action: string
    date: Date | string
  }[]
  trackings?: {
    trackingNumber: string
    trackingRecentNumber: string
    trackingDate: Date
    trackingStatusMessage: string
    trackingStatusMessageDesc: string
  }[]
  referrer?: {
    orderId: string
    platform: string
    aiRemark?: Record<string, any>
    aiSummary?: string
    [key: string]: any
  }
}

export interface IOrderSender {
  name: string
  address: string
  district: string
  subDistrict: string
  province: string
  zipcode: string
  phone: string
}

export interface IOrderItem {
  objectId?: string
  productCode: string
  productName: string
  productDescription: string
  category: string
  categoryName: string
  quantity: number
  price: number
  discount: number
  subTotal: number
  commission?: number
  total: number
  cost?: number
  free: boolean
  actor: string
  merchant: string
  commissionUsername?: string
  commissionUserFullName?: string
  imageUrl?: string
  isCollection?: boolean
  collections?: {
    productCode: string
    productName: string
    quantity: number
  }[]
  orderDate?: string
  orderDateType?: string
  meta: {
    color: string
    size: string
    weight: string
  }
}

export interface OrderTrackings {
  trackingNumber: string
  trackingDate: Date
  trackingStatus: string
  trackingStatusMessage: string
  trackingDetail: string
}

export interface OrderRecipient {
  name: string
  phone?: string
  email?: string
  address: string
  district: string
  subDistrict: string
  province: string
  zipcode: string
  social?: string
  crn?: string
}

export interface OrderSummary {
  count: number
  quantity: number
  discount: number
  codTelesale: number
  bankTelesale: number
  subTotal: number
  total: number
  commission: number
  commissionPercent: number
  commissionOrder: number
  codTotal: number
  codCount: number
  bankTotal: number
  bankCount: number
  returnTotal: number
  crmTotal: number
  costTotal: number
  countTelesale: number
  countTelesaleSuccess: number
  countTelesaleUnSuccess: number
  flash: number
  jnt: number
  kerry: number
  thaiPost: number
  bestExpress: number
  spxExpress: number
  upsaleTotal: number
  unsuccessUpSaleTotal: number
  telesaleTotal: number
  upsalePriceTotal?: number
}

export interface IOrderProvincePopular {
  name: string
  count: number
}

export interface IOrderProductTop10 {
  product: string
  productName: string
  count: number
  total: number
  quantity: number
}

export enum OrderShippingProvider {
  FLASH = 'flash',
  JNT = 'jnt',
  KERRY = 'kerry',
  THAIPOST = 'thaiPost',
  BESTEXPRESS = 'bestExpress',
  SPXEXPRESS = 'spx',
}

export enum EOrderPrintedStatus {
  PRINTED = 'printed',
  UNPRINTED = 'unprinted',
}

export enum EOrderStatus {
  AI = 'ai',
  PENDING = 'pending',
  TELESALE = 'telesale',
  SALEPAGE = 'salepage',
  TRACKING = 'tracking',
  SUCCESS = 'success',
  CANCLELLED = 'cancelled',
  RETURN = 'return',
  RETURNED = 'returned',
  TRANSIT = 'transit',
  DELIVERED = 'delivered',
}

export const OrderSatausLabel: Record<string, string> = {
  pending: 'รอส่งสินค้า',
  telesale: 'เทเลเซล',
  salepage: 'SalePage',
  tracking: 'สร้างหมายเลขพัสดุ',
  cancelled: 'ยกเลิก',
  success: 'สำเร็จ',
  return: 'ตีกลับ',
  returned: 'ตีกลับ (เซ็นรับแล้ว)',
  transit: 'ระหว่างขนส่ง',
  delivered: 'ส่งสำเร็จ',
}

export const OrderStatus = {
  ai: {
    label: 'AI',
    color: 'primary',
  },
  pending: {
    label: 'รอส่งสินค้า',
    color: 'warning',
  },
  telesale: {
    label: 'TeleSale',
    color: 'info',
  },
  salepage: {
    label: 'SalePage',
    color: '#a78bfa',
  },
  tracking: {
    label: 'สร้าง Tracking',
    color: 'primary',
  },
  cancelled: {
    label: 'ยกเลิก',
    color: 'error',
  },
  success: {
    label: 'สำเร็จ',
    color: 'success',
  },
  return: {
    label: 'ตีกลับ',
    color: 'error',
  },
  returned: {
    label: 'ตีกลับ (เซ็นรับแล้ว)',
    color: 'error',
  },
  transit: {
    label: 'ระหว่างขนส่ง',
    color: 'info',
  },
  delivered: {
    label: 'ส่งสำเร็จ',
    color: 'success',
  },
}

export enum EOrderType {
  COD = 'COD',
  BANK = 'BANK',
}

export enum EOrderDateType {
  CREATED = 'createdAt',
  ORDERDATE = 'orderDate',
  PICKUP = 'pickUpAt',
  PRINTED = 'printedAt',
  RETURN = 'return',
  TRACKING = 'trackingUpdatedAt',
}

export type ESortOrder = 'asc' | 'desc'

export enum EOrderOverdue {
  TRUE = 'true',
  FALSE = 'false',
  NULL = 'null',
}

export const enum EORDER_STATUS_CALL {
  CALLED = 'called',
  CANCELLED = 'cancelled',
  NOT_CALLED = 'not_called',
}
